import axios from "axios";

const getAuthToken = () => "BEARER " + window.localStorage.getItem("token");
const clearAuthToken = () => window.localStorage.removeItem("token");
const clearUser = () => window.localStorage.removeItem("user");

const isProduction = process.env.NODE_ENV === "production";

const httpClient = axios.create({
	baseURL: process.env.VUE_APP_SERVICES,
	timeout: 20000
});

httpClient.interceptors.request.use((config) => {
	if (window.localStorage.getItem("token")) {
		config.headers.Authorization = getAuthToken();
		// testing for IE10 or 11 to add a random string to help with a known IE cache bug
		// https://forum.vuejs.org/t/vue-js-in-ie-11-reactivity-issue-array-doesnt-update/10177
		if (/Trident\/|MSIE/.test(window.navigator.userAgent)) {
			config.params = {
				rand: new Date().getTime()
			};
		}
	}

	if (config && config.method) {
		console.log(
			`[${config.method.toUpperCase()}]`,
			`${config.baseURL}${config.url}`,
			!isProduction ? config.data || "" : ""
		);
	}
	return config;
});

// interceptor to catch errors
const errorInterceptor = (error) => {
	if (!error.response) {
		// connect this to bugsnag when we have it moved to central position.
		return Promise.reject(
			new Error(
				"oops it appears the server is unresponseive. Please try again shortly"
			)
		);
	}

	if (error && error.response && error.config.method) {
		console.error(
			`[${error.response.status} ${error.response.statusText}]`,
			`[${error.config.method.toUpperCase()}]`,
			`${error.config.baseURL}${error.config.url}`,
			error.response.data.errors
				? error.response.data.errors.map((e) => e.detail).join(", ")
				: error.response.data.error
		);

		if (error.response.status === 403) {
			clearAuthToken();
			clearUser();
			setTimeout(() => {
				(window as any).location = "/login";
			}, 0);
		}
	}

	return Promise.reject(error);
};

// Interceptor for responses
const responseInterceptor = (response) => {
	if (response && response.config.method) {
		console.log(
			`[${response.config.method.toUpperCase()}]`,
			`[${response.status} ${response.statusText}]`,
			`${response.config.baseURL}${response.config.url}`
		);
	}
	return response;
};

httpClient.interceptors.response.use(responseInterceptor, errorInterceptor);

export default httpClient;
